import {
    safelyGetFilterByKey,
    safelyGetRelationshipFilterIdsFromFilterValue,
} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

export const getEmailSequenceTemplateFilters = (
    activeFilters: FilterObject[]
): {
    creatorIds: string[];
    onlyArchived?: boolean;
    includeShared?: boolean;
    search?: string;
    includeUnsharedFromOthers: boolean;
} => {
    const creatorFilter = safelyGetFilterByKey(activeFilters, 'creator');
    const creatorIds = creatorFilter
        ? safelyGetRelationshipFilterIdsFromFilterValue(creatorFilter)
        : [];

    const archivedFilter = safelyGetFilterByKey(activeFilters, 'onlyArchived');
    const onlyArchived = archivedFilter === 'true';

    const justMineFilter = safelyGetFilterByKey(activeFilters, 'justMine');
    // switch to includeShared, because the frontend filter is the opposite of the backend filter
    const includeShared = justMineFilter !== 'true';

    const search = safelyGetFilterByKey(activeFilters, 'search');
    const includeUnsharedFromOthers = includeShared;

    return {creatorIds, onlyArchived, includeShared, search, includeUnsharedFromOthers};
};
